export { default } from "./SignInWeChatButton";
